export default ".././fonts/roboto-regular.woff2";